import { ScientificAnalysis, ScientificAnalysisFilter, ScientificAnalysisEntityFilters, SCIENTIFIC_ANALYSIS_CURRENT_SCHEMA_VERSION } from '@/modules/scientific-analysis-module/shared/scientific-analysis.models'
import { ScientificAnalysisSearchEntityType } from './services/scientific-analysis-dtos'

export interface ScientificAnalysisSelectedFilter {
    entityFilters: ScientificAnalysisEntityFilters
    filter: ScientificAnalysisFilter
    filterIndex: number
}

export interface ScientificAnalysisModuleState {
    scientificAnalysis: ScientificAnalysis
    renderResults: boolean
    selectedFilter: ScientificAnalysisSelectedFilter | null
}
export const initialScientificAnalysisModuleState =
    (): ScientificAnalysisModuleState => ({
        scientificAnalysis: {
            entityFilters: [],
            laboratoryIds: [],
            searchedEntityType: ScientificAnalysisSearchEntityType.CASE,
            sort: [],
            version: SCIENTIFIC_ANALYSIS_CURRENT_SCHEMA_VERSION
        },
        selectedFilter: null,
        renderResults: false
    })
